module.exports = __webpack_public_path__ + "img/A9.77143441.png";